import * as React from 'react';

import { RecentlyViewedModel } from 'models';

export interface ListingNameProps {
  name: string;
  ariaHidden?: boolean;
  visuallyHidden?: boolean;
  recentlyViewed?: RecentlyViewedModel;
}

export const ListingName: React.FunctionComponent<ListingNameProps> = ({
  name,
  ariaHidden = false,
  visuallyHidden = false,
  recentlyViewed = null
}) => {
  const classes = recentlyViewed
    ? 'truncate all-b-padding-half uitk-type-500 pwa-theme--grey-700'
    : 'pwa-theme--grey-900 truncate all-b-padding-half uitk-type-heading-500';

  return (
    <h3 className={classes} data-stid="content-hotel-title" aria-hidden={ariaHidden} hidden={visuallyHidden}>
      {name}
    </h3>
  );
};
ListingName.displayName = 'ListingName';
